module.exports = __webpack_public_path__ + "static/013-6a246a8c2ee2cad1b63ee457e556a127.png";